import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {Merchant} from "../MerchantStore";


@globalStore
export class MerchantFees extends BaseStore("MerchantFees") {
    @field(Number) merchantId: number;
    @field("Merchant") merchant: Merchant;
    @field(Number) purchaseFee: number;
    @field(Number) subscriptionFee: number;
    @field(Number) donationFee: number;
}

export async function apiAdminUpdateMerchantFees(data) {
    return apiClient.post("admin/merchants/update_fees/", data);
}
